import { IFormSettings } from 'formBuilder/src'

export const FormWrapper = (controls: any, formMeta: any) => {
	return {
		controls: controls,
		formMeta: formMeta,
	} as unknown as IFormSettings
}
